// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__zmQlj","description":"MealItem_description__WuaH6","price":"MealItem_price__EuYCy"};